// Caller-JWT APIs shared by the client app and the existing Communications UI.
export const FILE_BUCKET = 'client-files';
export const FILE_LIMIT = 10 * 1024 * 1024;
export const FILE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
export async function chatRpc(client, name, args) {
    const { data, error } = await client.rpc(name, args);
    if (error) throw new Error(error.message || 'Chat is unavailable. Please try again.');
    return data;
}
export function validateChatFile(file) {
    if (!file || !FILE_TYPES.includes(file.type) || !file.size || file.size > FILE_LIMIT) throw new Error('Choose a JPG, PNG, GIF, or PDF up to 10 MB.');
}
export async function uploadChatFile(client, accountId, file, tripId = null) {
    validateChatFile(file);
    const reserved = await chatRpc(client, 'm9_file_reserve', { p_account: accountId, p_fields: {
        name: file.name.slice(0, 180), size: file.size, mime: file.type, kind: 'chat', tripId,
    } });
    const { error } = await client.storage.from(FILE_BUCKET).upload(reserved.path, file, { contentType: file.type, upsert: false });
    if (error) throw error;
    return chatRpc(client, 'm9_file_complete', { p_file: reserved.id });
}
export async function signedChatFile(client, fileId) {
    const file = await chatRpc(client, 'm9_file_get', { p_file: fileId });
    const { data, error } = await client.storage.from(FILE_BUCKET).createSignedUrl(file.path, 300);
    if (error || !data?.signedUrl) throw error || new Error('File is unavailable.');
    return { ...file, url: data.signedUrl };
}
export function watchChat(client, accountId, refresh) {
    if (typeof client.channel !== 'function') return () => {};
    const channel = client.channel(`app-chat:${accountId}`).on('postgres_changes', {
        event: '*', schema: 'public', table: 'm9_chat_signals', filter: `account_id=eq.${accountId}`,
    }, refresh).subscribe();
    return () => { client.removeChannel?.(channel); };
}
